import { ModalAprovarPixComponent } from './aprovacao-pix/modal-aprovar-pix/modal-aprovar-pix.component';
import { AprovacaoPixComponent } from './aprovacao-pix/aprovacao-pix.component';
import { LogFinanceiraComponent } from './consulta-financeira/log-financeira/log-financeira.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackofficeComponent } from './backoffice.component';
import { MyDatePickerModule } from 'mydatepicker';
import { BackofficeRoutingModule } from './backoffice-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { GestaoUsuarioBackofficeComponent } from './gestao-usuario-backoffice/gestao-usuario-backoffice.component';
import { CadastroUsuarioBackofficeComponent } from './cadastro-usuario-backoffice/cadastro-usuario-backoffice.component';
import { AlteracaoUsuarioBackofficeComponent } from './alteracao-usuario-backoffice/alteracao-usuario-backoffice.component';
import { AutorizarNovoDispositivoComponent } from './autorizar-novo-dispositivo/autorizar-novo-dispositivo.component';
import { AlteracaoCadastralClienteComponent } from './alteracao-cadastral-cliente/alteracao-cadastral-cliente.component';
import { CriarSenhaTemporariaComponent } from './criar-senha-temporaria/criar-senha-temporaria.component';
import { ExtratoContaBmpComponent } from './extrato-conta-bmp/extrato-conta-bmp.component';
import { ExtratoContaOrbitalComponent } from './extrato-conta-orbital/extrato-conta-orbital.component';
import { ExtratoContaUsuarioComponent } from './extrato-conta-usuario/extrato-conta-usuario.component';
import { ConsultaFinanceiraComponent } from './consulta-financeira/consulta-financeira.component';
import { GestaoOnboardingComponent } from './gestao-onboarding/gestao-onboarding.component';
import { JobSchedulerComponent } from './job-scheduler/job-scheduler.component';
import { GestaoOnboardingDetailsComponent } from './gestao-onboarding-details/gestao-onboarding-details.component';
import { GestaoRequisitarCartoesComponent } from './gestao-requisitar-cartoes/gestao-requisitar-cartoes.component';
import { ModalVisualizarOnboardComponent } from './gestao-onboarding-details/modal-visualizar-onboard/modal-visualizar-onboard.component';
import { GestaoRequisitarCartoesDetailsComponent } from './gestao-requisitar-cartoes-details/gestao-requisitar-cartoes-details.component';
import { ModalVisualizarRequisitarCartoesComponent } from './gestao-requisitar-cartoes-details/modal-visualizar-requisitar-cartoes/modal-visualizar-requisitar-cartoes.component';
import { ConsultaMovimentacoesPixComponent } from './consulta-movimentacoes-pix/consulta-movimentacoes-pix.component';
import {ModalDetalhesExtratoComponent} from './extrato-conta-usuario/modal-detalhes-extrato/modal-detalhes-extrato.component';
import { RestringirMccProdutoComponent } from './restringir-mcc-produto/restringir-mcc-produto.component';
import { RestringirMccProdutoClienteCartaoComponent } from './restringir-mcc-produto-cliente-cartao/restringir-mcc-produto-cliente-cartao.component';
import { RestringirMccProdutoClienteCartaoEditComponent } from './restringir-mcc-produto-cliente-cartao/restringir-mcc-produto-cliente-cartao-edit/restringir-mcc-produto-cliente-cartao-edit.component';
import { TripleListModule } from '../../shared/components/tripleList/triple-list.module';
import { RestringirMccClienteComponent } from './restringir-mcc-cliente/restringir-mcc-cliente.component';
import { ImportarCartaoComponent } from './gestao-estoque/importar-cartao/importar-cartao.component';
import { ModalConfirmarEstoqueComponent } from './gestao-estoque/modal-confirmar-estoque/modal-confirmar-estoque.component';
import { ValeEstarBemModule } from './vale-estar-bem/vale-estar-bem.module';
import { ModalCofirmacaoComponent } from '../../shared/components/modal-confirmacao/modal-confirmacao.component';
import { ModalNovoBeneficiarioComponent } from './vale-estar-bem/gestao-beneficiario/modal-novo-beneficiario/modal-novo-beneficiario.component';
import { DirectivesModule } from '../../shared/directive/directives.module';

@NgModule({

  imports: [
    CommonModule,
    BackofficeRoutingModule,
    NbCheckboxModule,
    MyDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    TripleListModule,
    ValeEstarBemModule,
    DirectivesModule
  ],
  exports: [
    MyDatePickerModule,
  ],
  declarations: [
    BackofficeComponent,
    AlteracaoCadastralClienteComponent,
    GestaoUsuarioBackofficeComponent,
    CadastroUsuarioBackofficeComponent,
    AlteracaoUsuarioBackofficeComponent,
    AutorizarNovoDispositivoComponent,
    CriarSenhaTemporariaComponent,
    ExtratoContaBmpComponent,
    ExtratoContaOrbitalComponent,
    ExtratoContaUsuarioComponent,
    ConsultaFinanceiraComponent,
    LogFinanceiraComponent,
    GestaoOnboardingComponent,
    JobSchedulerComponent,
    AprovacaoPixComponent,
    ModalAprovarPixComponent,
    ModalDetalhesExtratoComponent,
    GestaoOnboardingDetailsComponent,
    ModalVisualizarOnboardComponent,
    GestaoRequisitarCartoesComponent,
    GestaoRequisitarCartoesDetailsComponent,
    ModalVisualizarRequisitarCartoesComponent,
    ConsultaMovimentacoesPixComponent,
    RestringirMccProdutoComponent,
    RestringirMccProdutoClienteCartaoComponent,
    RestringirMccProdutoClienteCartaoEditComponent,
    RestringirMccClienteComponent,
    ImportarCartaoComponent,
    ModalConfirmarEstoqueComponent,
    ModalNovoBeneficiarioComponent
  ],
  entryComponents: [
    ModalAprovarPixComponent,
    ModalDetalhesExtratoComponent,
    ModalVisualizarOnboardComponent,
    ModalVisualizarRequisitarCartoesComponent,
    ModalConfirmarEstoqueComponent,
    ModalCofirmacaoComponent,
    ModalNovoBeneficiarioComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BackofficeModule { }
